<!-- eslint-disable max-len -->
<template>
  <svg fill="none" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.9998 15.1996L17.7998 12.0996L13.8998 12.2996L4.4998 12.8996C1.5998 13.0996 0.799805 15.3996 0.799805 15.3996"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="0.8"
    />
    <path
      d="M0.700195 16.8002C2.4002 17.1002 2.4002 16.5002 3.4002 15.9002C3.9002 16.2002 5.2002 17.2002 7.3002 16.2002C7.6002 16.4002 8.3002 16.8002 9.2002 16.8002C10.1002 16.8002 11.3002 16.6002 12.2002 15.7002C14.4002 17.1002 15.3002 16.5002 16.2002 16.3002"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="0.8"
    />
    <path d="M4.7998 12.7996V10.2996L11.6998 10.0996L14.6998 12.1996" stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-width="0.8" />
    <path d="M6.10059 10.1V8.5H7.70059L9.20059 10.1" stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-width="0.8" />
    <path d="M9.9002 3.0998L6.4002 1.2998L4.7002 1.7998L6.9002 3.6998" stroke="black" stroke-linecap="round" stroke-miterlimit="10" stroke-width="0.8" />
    <path
      d="M16.4006 3.89995C16.2006 3.39995 15.4006 3.09995 14.7006 3.29995L5.40059 5.59995L3.60059 4.79995L2.10059 5.19995L3.50059 7.09995H7.90059L15.6006 5.19995C16.3006 4.99995 16.7006 4.49995 16.4006 3.89995Z"
      stroke="black"
      stroke-linecap="round"
      stroke-miterlimit="10"
      stroke-width="0.8"
    />
  </svg>
</template>
